export default "__VITE_ASSET__CslMasdg__"